import { API_BASE_URL } from "../app_url";
import axios from "axios";

export const getAuthToken = () => {
  try {
    const value = JSON.parse(localStorage.getItem("doctolikLoginInfo"));
    return value?.authorisation?.token ?? null;
  } catch {
    return null;
  }
};

const getHeader = () => {
  const token = getAuthToken();
  return {
    headers: {
      ...(token ? { Authorization: "Bearer " + token } : {}),
      'Cache-Control': 'no-cache',
    },
  };
};

const getMultipartHeader = () => {
  const token = getAuthToken();
  return {
    headers: {
      ...(token ? { Authorization: "Bearer " + token } : {}),
      'Content-Type': 'multipart/form-data',
      'Cache-Control': 'no-cache',
    },
  };
};



export const getParentApi = (nurseId, params = {}) => {
  return axios.get(API_BASE_URL + `nurse/get-parent`, {
    ...getHeader(),
    params: {
      ...params,
      nurse_id: nurseId
    }
  });
}

// Chatroom Management
export const getChatroomApi = () => {
  return axios.get(API_BASE_URL + `doctor/assistant-chat/chatroom`, getHeader());
};

export const getChatroomByDoctorIdApi = (doctorId) => {
  return axios.get(API_BASE_URL + `doctor/assistant-chat/chatroom/doctor/${doctorId}`, getHeader());
};

export const getAllChatroomsApi = () => {
  return axios.get(API_BASE_URL + `doctor/assistant-chat/chatrooms`, getHeader());
};

// Member Management
export const addMemberApi = (chatroomId, userId, role = 'assistant') => {
  return axios.post(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/members`,
    { user_id: userId, role },
    getHeader()
  );
};

export const removeMemberApi = (chatroomId, userId) => {
  return axios.delete(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/members/${userId}`,
    getHeader()
  );
};

export const getChatroomMembersApi = (chatroomId) => {
  return axios.get(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/members`,
    getHeader()
  );
};

// Message Operations
export const sendMessageApi = (chatroomId, message, messageType = 'text', extra = {}) => {
  return axios.post(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/messages`,
    { message, message_type: messageType, ...extra },
    getHeader()
  );
};

export const sendFileMessageApi = (chatroomId, file, message, messageType) => {
  const formData = new FormData();
  formData.append('message', message);
  formData.append('message_type', messageType);
  formData.append('file', file);

  return axios.post(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/messages`,
    formData,
    getMultipartHeader()
  );
};

export const getMessagesApi = (chatroomId, perPage = 50, beforeMessageId = null) => {
  const params = { per_page: perPage };
  if (beforeMessageId) {
    params.before_message_id = beforeMessageId;
  }
  
  return axios.get(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/messages`,
    { ...getHeader(), params }
  );
};

export const loadMoreMessagesApi = (chatroomId, beforeMessageId = null) => {
  const params = beforeMessageId ? { before_message_id: beforeMessageId } : {};
  
  return axios.get(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/messages/load-more`,
    { ...getHeader(), params }
  );
};

export const markMessageAsReadApi = (messageId) => {
  return axios.patch(
    API_BASE_URL + `doctor/assistant-chat/messages/${messageId}/read`,
    {},
    getHeader()
  );
};

export const markAllMessagesAsReadApi = (chatroomId) => {
  return axios.patch(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/read-all`,
    {},
    getHeader()
  );
};

export const deleteMessageApi = (messageId) => {
  return axios.delete(
    API_BASE_URL + `doctor/assistant-chat/messages/${messageId}`,
    getHeader()
  );
};

// Utility
export const getUnreadCountApi = (chatroomId) => {
  return axios.get(
    API_BASE_URL + `doctor/assistant-chat/chatroom/${chatroomId}/unread-count`,
    getHeader()
  );
};
